module.exports = __webpack_public_path__ + "img/login-issue.cc19565a.webp";